import React, { useState } from "react";
import styled from "styled-components";
import TextField from "../../parts/TextField";
import FormGroup from "../../parts/FormGroup";
import { useNavigate } from "react-router";
import ButtonSubmit from "../../parts/ButtonSubmit";
import Alert from "../../parts/Alert";
import { api } from "../../../../api";

const LoginFormStyle = styled(FormGroup)`
  background: none;
  text-align: center;
  max-width: 500px;
  margin: auto;
  margin-bottom: 10px;
`;

const SignUpButtonStyle = styled(ButtonSubmit)`
  max-width: 250px;
  width: 100%;
`;

const OwnerLoginForm: React.FC = () => {
  const [email, setEmail] = useState<string>();
  const [password, setPassword] = useState<string>();
  const [message, setMessage] = useState(null);
  const [messageLevel, setMessageLevel] = useState(null);
  const navigate = useNavigate();

  const handleSubmit = (event) => {
    event.preventDefault();
    api
      .ownerLogin({
        owner: {
          email,
          password,
        },
      })
      .then(() => {
        navigate("/owner/dashboard");
      })
      .catch((error) => {
        setMessage(error.response.data.message);
        setMessageLevel("error");
      });
  };

  return (
    <LoginFormStyle onSubmit={handleSubmit}>
      <TextField
        type="text"
        placeholder="メールアドレス"
        mb="20px"
        onChange={(event) => setEmail(event.target.value)}
        required={true}
      />
      <TextField
        type="password"
        placeholder="パスワード"
        mb="20px"
        onChange={(event) => setPassword(event.target.value)}
        required={true}
      />
      <SignUpButtonStyle value="ログイン" />
      {message && <Alert level={messageLevel}>{message}</Alert>}
    </LoginFormStyle>
  );
};
export default OwnerLoginForm;
